import { useEffect } from 'react';

const addBodyClass = className => document.body.classList.add(className);
const removeBodyClass = className => document.body.classList.remove(className);

export default function useBodyClass(className) {
  useEffect(() => {
    // Set up
    if (Array.isArray(className)) {
      for (const cls of className) {
        addBodyClass(cls);
      }
    } else {
      addBodyClass(className);
    }

    // Clean up
    return () => {
      if (Array.isArray(className)) {
        for (const cls of className) {
          removeBodyClass(cls);
        }
      } else {
        removeBodyClass(className);
      }
    };
  }, [className]);
}
